import React,{useState} from 'react'
import MyLocationIcon from '@mui/icons-material/MyLocation';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Symbol from './Symbol';
import DrawerLeft from './DrawerLeft';

export default function SideMain(props) {
    const {the_temp,weather_state_name}=props.weatherArr;
    const [IsOpen, setIsOpen] = useState(false);
    function onClose(){
        setIsOpen(false);
    }
    var dateObj=new Date();
    var arr=dateObj.toString().trim().split(" ");
    
    var date=arr[0]+","+arr[2]+" "+arr[1];
   
   
    return (
        <div className="boxColor sideBox">
            <div className="buttonContainer">
                <div className="searchButton flexCenter sideButton" onClick={()=>{
                    setIsOpen(true);
                }}><p className="text buttonText">Search for Places</p></div>
                <div className="locationButton flexCenter text sideButton" onClick={()=>{
                    props.getByUserLocation();
                }}>
                    <MyLocationIcon/>
                </div>
            </div>
            <div className="imageDiv flexCenter">
                <img src={weather_state_name.replace(' ',"")+".png"} alt="weatherimage"></img>
            </div>
            <h1 className="tempMainHeading flexCenter text">{the_temp.toFixed(2)}<span className="degree secondTextColor">°C</span></h1>
            <p className="secondTextColor flexCenter weatherTypeText">{weather_state_name}</p>
            <div class="bottomContainers dateContainer flexCenter">
                <p>Today</p>
                <p>.</p>
                <p>{date}</p>
            </div>
            <Symbol name={()=>{
                return <LocationOnIcon/>
            }} title={props.currPlace}/>
           
            <DrawerLeft IsOpen={IsOpen} onClose={onClose} places={props.places} selectPlace={props.selectPlace} searchPlace={props.searchPlace}/>
        </div>
        
    )
}
